import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
export function TestimonialsPage() {
  const {
    t
  } = useLanguage();
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 pb-20 bg-white min-h-screen" data-id="element-362">
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 overflow-hidden bg-teal-50/50" data-id="element-363">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-364">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-teal-100/40 blur-3xl" data-id="element-365" />
          <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-teal-50/60 blur-3xl" data-id="element-366" />
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-367">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-368">
            <h1 className="text-4xl md:text-5xl font-serif font-medium text-teal-900 mb-6" data-id="element-369">
              {t.testimonials.title}
            </h1>
            <p className="text-xl text-slate-600 mb-4" data-id="element-370">
              {t.testimonials.subtitle}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-372">
          {t.testimonials.list.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 border border-teal-100 shadow-sm hover:shadow-md transition-shadow relative" data-id="element-373">
              <QuoteIcon className="text-teal-100 absolute top-6 right-6 w-12 h-12 -z-0" data-id="element-374" />
              <div className="relative z-10" data-id="element-375">
                <p className="text-slate-700 text-lg italic mb-6 leading-relaxed" data-id="element-376">
                  "{testimonial.quote}"
                </p>
                <div className="mt-auto pt-6 border-t border-slate-100" data-id="element-377">
                  <h4 className="font-medium text-teal-900 text-lg" data-id="element-378">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-teal-600 font-medium mb-1" data-id="element-379">
                    {testimonial.context}
                  </p>
                  {testimonial.date && <p className="text-xs text-slate-400" data-id="element-380">{testimonial.date}</p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}